const ValidationPatterns = {
    strongPassword: /^(?=.*[a-z]+.*)(?=.*[A-Z]+.*)(?=.*[0-9]+.*)(?=.*[`~!@#$%^&*()\\]\\[+={}/|:;\"\'<>,.?-_]+.*).{12,}$/,
    mediumPassword: /^(?=.*[a-z]+.*)(?=.*[A-Z]+.*)(?=.*[0-9]+.*)(?=.*[`~!@#$%^&*()\\]\\[+={}/|:;\"\'<>,.?-_]+.*).{8,}$/,
    weakPassword:   /^(?=.*[a-z]+.*)(?=.*[A-Z]+.*)(?=.*[0-9]+.*).{8,}$/,
    telephone: /^\+[1-9]\d{1,14}$/,
    email: /^((([!#$%&'*+\-/=?^_`{|}~\w])|([!#$%&'*+\-/=?^_`{|}~\w][!#$%&'*+\-/=?^_`{|}~\.\w]{0,}[!#$%&'*+\-/=?^_`{|}~\w]))[@]\w+([-.]\w+)*\.\w+([-.]\w+)*)$/,
    countryCode: /^A[^ABCHJKNPVY]|B[^CKPUX]|C[^BEJPQST]|D[EJKMOZ]|E[CEGHRST]|F[IJKMOR]|G[^CJKOVXZ]|H[KMNRTU]|I[DEL-OQ-T]|J[EMOP]|K[EGHIMNPRWYZ]|L[ABCIKR-VY]|M[^BIJ]|N[ACEFGILOPRUZ]|OM|P[AE-HK-NRSTWY]|QA|R[EOSUW]|S[^FPQUW]|T[^ABEIPQSUXY]|U[AGMSYZ]|V[ACEGINU]|WF|WS|YE|YT|Z[AMW]$/,
}

export default ValidationPatterns